import React, { useState, useEffect } from 'react';
// import { removeHost } from "../../utils/functions";
import CategorySideBar from './CategorySideBar';
import CategoriesList from './CategoriesList';
import CategoryHero from './CategoryHero';
import SubCategories from './SubCategories';
import CategoriesFilterSort from './CategoriesFilterSort';
import Breadcrumbs from '../breadcrumbs/Breadcrumbs'
import ProductsList from '../productsList/ProductsList';
import CategoriesFilterPrice from './CategoriesFilterPrice';
import "./style.scss"


const CategoryContent = ({ lang, id, children, products, options, breadcrumbs, title, description, productBoxButton }) => {
  const [priceFilterStart, setPriceFilterStart] = useState([0, 1]);
  const [priceFilter, setPriceFilter] = useState([0, 1]);
  const [typeFilter, setTypeFilter] = useState('');
  const [productsItems, setProductsItems] = useState([]);
  const [productsItemsStarter, setProductsItemsStarter] = useState([]);
  const regex = /(\d+([\.\,\s]\d{1,}){1,}([\.\,\s]\d{1,2})?)/
  const { buttonprice, headingCategories, headingPrice, headingSort, textprice, typeSort, currency } = options
  useEffect(() => {
    setTypeFilter(typeSort[0].type);
    let tmp = [];
    let tmpProducts = [];
    products.nodes.forEach(product => {
      const price = product.salePrice ? product.salePrice : product.regularPrice
      if (price) {
        const priceRegex = price.match(regex);
        // console.log(priceRegex[0]);
        const priceReplace = priceRegex[0].replace(',', '.');
        const priceFloat = parseFloat(priceReplace);
        tmp.push(priceFloat);
        tmpProducts.push({
          ...product,
          floatPrice: priceFloat
        })
      }
    });
    setProductsItems(tmpProducts);
    setProductsItemsStarter(tmpProducts);
    setPriceFilterStart([0, parseInt(Math.max(...tmp) + 1)])
    setPriceFilter([0, parseInt(Math.max(...tmp) + 1)])
  }, [])

  const filter = ((type, value) => {
    let tmp = [...productsItems]
    if (type === 'sort') {
      setTypeFilter(value);
      switch (value) {
        case 'popularity':
          tmp = [...productsItemsStarter]
          break;
        case 'az':
          tmp.sort((a, b) => a.name.localeCompare(b.name))
          break;
        case 'za':
          tmp.sort((a, b) => b.name.localeCompare(a.name))
          break;
        case 'lowPrice':
          tmp.sort((a, b) => a.floatPrice - b.floatPrice)
          break;
        case 'hightPrice':
          tmp.sort((a, b) => b.floatPrice - a.floatPrice)
          break;
        default:
          break;
      }
    }
    if (type === 'price') {
      tmp = [...productsItemsStarter]
      switch (typeFilter) {
        case 'popularity':
          tmp = [...productsItemsStarter]
          break;
        case 'az':
          tmp.sort((a, b) => a.name.localeCompare(b.name))
          break;
        case 'za':
          tmp.sort((a, b) => b.name.localeCompare(a.name))
          break;
        case 'lowPrice':
          tmp.sort((a, b) => a.floatPrice - b.floatPrice)
          break;
        case 'hightPrice':
          tmp.sort((a, b) => b.floatPrice - a.floatPrice)
          break;
        default:
          break;
      }
      tmp = tmp.filter((item) => item.floatPrice >= value[0] && item.floatPrice <= value[1]);
    }
    setProductsItems(tmp)
  });


  const getContent = ((type) => {
    if (type === 'subcat') {
      return (<div className="container">
        <div className="productCategories">
          <Breadcrumbs breadcrumbsList={breadcrumbs} />
          <div className="productCategories__wrapper">
            <div className="productCategories__sideBar">
              <CategorySideBar>
                <CategoriesList lang={lang} breadcrumbs={breadcrumbs} heading={headingCategories} />
              </CategorySideBar>
            </div>
            <div className="productCategories__content">
              <CategoryHero title={title} description={description} />
              <SubCategories categories={children} />
            </div>
          </div>
        </div>
      </div>
      )
    }
    else {
      return (<div className="container">
        <div className="productCategories">
          <Breadcrumbs breadcrumbsList={breadcrumbs} />
          <div className="productCategories__wrapper">
            <div className="productCategories__sideBar">
              <CategorySideBar>
                <CategoriesFilterPrice
                  heading={headingPrice}
                  text={textprice}
                  button={buttonprice}
                  priceFilterStart={priceFilterStart}
                  filter={filter}
                  priceFilter={priceFilter}
                  currency={currency}
                  setPriceFilter={setPriceFilter} />
                <CategoriesFilterSort type={typeSort} heading={headingSort} typeFilter={typeFilter} filter={filter} />
                <CategoriesList lang={lang} breadcrumbs={breadcrumbs} heading={headingCategories} />
              </CategorySideBar>
            </div>
            <div className="productCategories__content">
              <CategoryHero title={title} description={description} />
              <ProductsList productBoxButton={productBoxButton} products={productsItems} columns={3} />
            </div>
          </div>
        </div>
      </div>
      )
    }
  });

  return (
    children ? (
      children.nodes.length ? (
        getContent('subcat')
      ) :
        (
          getContent('cat')
        )

    ) :
      (
        getContent('cat')
      )
  )
  // if (children) {
  //   if (children.nodes.length) {
  //     return (

  //     )
  //   }
  //   else {
  //     return (

  //     )
  //   }
  // }
}
export default CategoryContent
